var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgEdit(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.972 26.571a3.471 3.471 0 01-1.056 2.441 3.503 3.503 0 01-2.479.988H5.54a3.51 3.51 0 01-2.485-.988A3.48 3.48 0 012 26.566V12.521c.015-.922.396-1.8 1.059-2.442a3.51 3.51 0 012.481-.987h20.892a3.549 3.549 0 012.478.99 3.356 3.356 0 011.056 2.439l.006 14.05z",
    fill: "#66BFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.152 13.82a2.414 2.414 0 00-2.256-2.565 2.418 2.418 0 00-2.588 2.234 2.415 2.415 0 002.256 2.565 2.418 2.418 0 002.588-2.234z",
    fill: "#F2FBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.66 28.288v1.734H5.54a3.51 3.51 0 01-2.493-.995A3.478 3.478 0 012 26.565v-3.149l1.444-1.403 2.276-2.238a3.036 3.036 0 014.209 0l2.28 2.238 6.452 6.275z",
    fill: "#487DB3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.966 21.297v5.274a3.459 3.459 0 01-1.054 2.444 3.49 3.49 0 01-2.48.985H6.578l5.99-5.951 5.13-5.096 3.051-3.026a2.687 2.687 0 011.905-.788 2.698 2.698 0 011.905.788l3.046 3.026 2.36 2.344z",
    fill: "#5798D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.607 18.953H17.7l3.051-3.026a2.687 2.687 0 011.905-.788 2.698 2.698 0 011.905.788l3.046 3.026zM12.216 22.013H3.45l2.276-2.238a3.036 3.036 0 014.209 0l2.281 2.238z",
    fill: "#F2FBFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.91 10.088l-7.771 13.385a3.997 3.997 0 01-1.34 1.382 4.02 4.02 0 01-1.835.598l-2.714.2 9.31-16.555h1.872a3.549 3.549 0 012.478.99z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.831 5.138L19.19 23.478a2.103 2.103 0 01-.894.845l-2.023.973L29.056 3.264l.32.185a1.24 1.24 0 01.611 1.232 1.232 1.232 0 01-.156.457z",
    fill: "#CC5151"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.471 2.352L14.688 24.373l-.158-2.237c-.029-.422.069-.842.282-1.208L25.447 2.62a1.241 1.241 0 011.686-.453l.337.184z",
    fill: "#FF8080"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.056 3.264L16.272 25.296l-.595.291a.66.66 0 01-.852-.253.652.652 0 01-.092-.306l-.046-.655 12.784-22.02 1.585.911z",
    fill: "#E65C5C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.205 23.45a2.104 2.104 0 01-.91.873l-1.158.56-1.444.698a.66.66 0 01-.944-.559l-.112-1.594-.09-1.28c-.03-.422.069-.843.281-1.209l4.377 2.511z",
    fill: "#FFE2B3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.12 24.888l-1.444.699a.66.66 0 01-.944-.56l-.112-1.593 2.5 1.454z",
    fill: "#E65C5C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.831 5.138l-.297.526-4.378-2.517.304-.526a1.241 1.241 0 011.685-.453l2.248 1.28a1.231 1.231 0 01.438 1.69z",
    fill: "#FFE2B3"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h28v28H0z"
  })))));
}
export default SvgEdit;